export default {
  "home": "Дом",
  "not_found": "Ненайдено",
  "greeting": "Привет",
  "logout": "Выйти",
}
